import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from './ui/card';
import { Calendar, Image as ImageIcon } from 'lucide-react';

const HaberlerSection = () => {
  const { t, language } = useLanguage();
  const [news] = useState([
    /*
    {
      id: 1,
      title: 'Yeni Tesis Açılışı',
      titleEn: 'New Facility Opening',
      content: 'Kar Yemek Sanayi, modern üretim tesislerini hizmete açtı. Yeni tesislerimizle günlük üretim kapasitemizi artırdık.',
      contentEn: 'Kar Yemek Industry has opened its modern production facilities. We have increased our daily production capacity with our new facilities.',
      image: '',
      date: '2024-01-15',
    },
    {
      id: 2,
      title: 'ISO 22000 Belgemizi Yeniledik',
      titleEn: 'ISO 22000 Certificate Renewed',
      content: 'Gıda güvenliği yönetim sistemi belgemizi başarıyla yeniledik.',
      contentEn: 'We have successfully renewed our food safety management system certificate.',
      image: '',
      date: '2024-01-10',
    },
    {
      id: 3,
      title: 'Çevre Ödülü',
      titleEn: 'Environmental Award',
      content: 'Sürdürülebilir üretim uygulamalarımız nedeniyle Çevre Ödülü\'ne layık görüldük.',
      contentEn: 'We have been awarded the Environmental Award for our sustainable production practices.',
      image: '',
      date: '2024-01-05',
    },
    */
  ]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(language === 'tr' ? 'tr-TR' : 'en-US', options);
  };

  return (
    <section id="haberler" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t('news.title')}
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto"></div>
        </div>

        {/* News Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {news.map((item) => (
            <Card
              key={item.id}
              className="border-none shadow-lg hover:shadow-xl transition-all overflow-hidden group"
            >
              {/* Image Area */}
              <div className="h-48 bg-gray-200 relative overflow-hidden">
                {item.image ? (
                  <img
                    src={item.image}
                    alt={language === 'tr' ? item.title : item.titleEn}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-gray-400">
                    <ImageIcon className="w-16 h-16 mb-2" />
                    <span className="text-sm">Haber Görseli</span>
                  </div>
                )}

                {/* Date Badge */}
                <div className="absolute top-4 left-4 bg-amber-500 text-white px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1">
                  <Calendar className="w-4 h-4" />
                  {formatDate(item.date)}
                </div>
              </div>

              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-amber-600 transition-colors">
                  {language === 'tr' ? item.title : item.titleEn}
                </h3>
                <p className="text-gray-600 line-clamp-3">
                  {language === 'tr' ? item.content : item.contentEn}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HaberlerSection;